var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNB)?_c('app-nabi'):_vm._e(),_c('router-view'),(_vm.showNB)?_c('app-boyd'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }